import { FC, useCallback } from 'react';
import { useField } from 'formik';

import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

export type Range = {
  start: number;
  end: number;
};

type Props = Omit<
  AutocompleteProps<Range, true, false, true>,
  'options' | 'renderOption' | 'filterOptions' | 'renderInput'
> & {
  name: string;
  label?: string;
};

const RangeSelector: FC<Props> = props => {
  const { name, label, placeholder, ...rest } = props;
  const [{ value }, , { setValue }] = useField<Range[]>(name);

  const handleChange = useCallback(
    (_, inputValue: any[]) => {
      const newValue = inputValue.map(item => {
        if (/^([0-9]+)\s*-\s*([0-9]+)$/.test(item)) {
          const [start, end] = item.split('-');
          return { start: parseInt(start), end: parseInt(end) };
        }

        return item as Range;
      });

      setValue(newValue);
    },
    [setValue]
  );

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={value}
      onChange={handleChange}
      renderTags={(value, getTagProps) =>
        value.map((tag, index) => (
          <Chip
            label={`${tag.start} - ${tag.end}`}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeholder}
        />
      )}
      {...rest}
    />
  );
};

export default RangeSelector;
